import React from "react";
import "./edittext.scss";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { useTranslation } from "react-i18next";


const EditTextField = ({ value, vehicleList, mode, statedata, handleChange, getVehiclecatList, handleFileUploads, handleDeletefile, fileInputRefs, catalogue_file, getVehicleList, catalogueEdit_file }) => {
  const handleDownloadFile = (url) => {
    let fileURL;
    if (catalogue_file) {
      fileURL = encodeURIComponent(URL.createObjectURL(catalogue_file));
      const downloadLink = document.createElement("a");
      downloadLink.href = decodeURIComponent(fileURL)
      downloadLink.download = catalogue_file?.name;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }else if(url){
      fileURL = encodeURIComponent(url);
      window.location.href = decodeURIComponent(fileURL);
    }else {
      return "No file to download";
    }
  };
  
  const { i18n, t } = useTranslation();

  return (
    <div>
      <div className="edit_textfield">
        <div className="partlistdropdowndiv">
          <div class="input-wrapper">
            <label for="first" className="label_edittext required">{t('addcatalogues.vehiclecategory')}</label>
            <select name="vehicle_category" id="vehicle_category" className="new_part-select"
              value={mode == "Edit" ? value?.vehicle_category : statedata?.vehicle_category}
              onChange={handleChange}>
              <option value="" className="select_category" placeholder="Select category">{t('addcatalogues.selectcategory')}</option>
              {vehicleList?.map((data, i) =>
                <option
                  //  value={data.id}>{data.name}
                  value={mode === "Edit" ? data?.name : data?.id} key={i}>{data.name}
                </option>
              )}
            </select>
          </div>
        </div>
        <div className="partlistdropdowndiv">
          <div class="input-wrapper">
            <label for="first" className="label_edittext required">{t('addcatalogues.vehiclename')}</label>
            <select
              className="new_part-select"
              name="vehicle_name" id="vehicle_id"
              value={mode === "Edit" ? (value?.vehicle_id ? value?.vehicle_id : "") : (statedata?.vehicle_name ? statedata?.vehicle_name : "")}
              onChange={handleChange}
            >
              <option value="" className="select_category">
              {t('addcatalogues.selectvehicle')}
              </option>
              {mode === "Edit" ?
                getVehicleList?.map((data, i) => (
                  <option value={mode === "Edit" ? (data?.id ? data?.id : "") : (data?.id ? data?.id : "")} key={i}>
                    {data?.name}
                  </option>
                )) :
                getVehiclecatList?.map((data, i) => (
                  <option value={mode === "Edit" ? (data?.id ? data?.id : "") : (data?.id ? data?.id : "")} key={i}>
                    {data?.name}
                  </option>
                ))}
            </select>
          </div>
        </div>
      </div>
      <div className="edit_textfield-input">
        <div className="partlistdropdowndiv_file">
          <div class="input-wrapper">
            <label for="search" className="label_edittext required" htmlFor="banner4">{t('addcatalogues.selectfile')}</label>
            <input
              type="file"
              id="banner4"
              ref={fileInputRefs}
              accept=".pdf"
              hidden
              onChange={handleFileUploads}
              className="selectfile" placeholder="Enter Value"
            // value={mode == "Edit" ? value.catalogue_file :"" }
            />
            <input
              type="text"
              readOnly
              className="selectfile" placeholder={t('addcatalogues.selectfile')}
              value={
                mode === "Edit" ? (catalogueEdit_file?.name ? catalogueEdit_file?.name : value?.catalogue_file_name) : (catalogue_file?.name || "")
              }
            // value={mode == "Edit" ? value?.catalogue_file : catalogue_file?.name}
            />
            <label className="select-input" htmlFor="banner4">{t('addcatalogues.upload')}<button className="download-button" onClick={(e)=>handleDownloadFile(catalogue_file?catalogue_file:value?.catalogue_file)} disabled={!catalogue_file && mode !== "Edit"} >
            <FaCloudDownloadAlt />
            </button></label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTextField;
